import { Box, Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export interface SidepanelFooterActionProps {
  loading: boolean
  disabledSave: boolean
  hideDeleteButton?: boolean
  onSave: () => void
  onDelete: () => void
}

export const SidepanelFooterAction = ({
  loading,
  disabledSave,
  hideDeleteButton,
  onSave,
  onDelete,
}: SidepanelFooterActionProps) => {
  return (
    <Box flexDirection="rowReverse" justifyContent="spaceBetween" width="full">
      <Button disabled={disabledSave || loading} onClick={onSave} type="positive">
        {i18n.t('common.save')}
      </Button>
      {!hideDeleteButton && (
        <Button disabled={loading} onClick={onDelete} type="negative">
          {i18n.t('banking.accounts.delete.modal.title')}
        </Button>
      )}
    </Box>
  )
}
